import type { NewUser } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useAddUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: NewUser) =>
      post({
        url: `/users`,
        body: params,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUsers(false),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUsers(true),
      });
    },
  });

  const addUser = useCallback((params: NewUser) => mutate(params), [mutate]);

  return {
    addUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
